import gql from 'graphql-tag';

export const Forms = gql`
  query Forms($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      forms {
        id
        type
        name
        url
        externalId
        labelMappings {
          create {
            id
            name
            description
            color
          }
          update {
            id
            name
            description
            color
          }
        }
      }
    }
  }
`;
